<span class="app-select__trigger">
  <span class="app-select__value-wrapper">
    <span *ngIf="empty" class="app-select__placeholder">{{ placeholder }}</span>
    <!-- Property binding instead of `{{ }}` interpolation: Prettier
         reformats a flush `<span>{{ value }}</span>` back to multi-line,
         and Angular keeps a single space between the tag and the
         interpolation when they sit on separate lines — that whitespace
         leaks into `nativeElement.textContent` and breaks consumer specs
         that compare against the option's viewValue verbatim. -->
    <span
      *ngIf="!empty"
      class="app-select__value-text"
      [textContent]="triggerValue"
    ></span>
  </span>
  <span class="app-select__arrow-wrapper">
    <span class="app-select__arrow"></span>
  </span>
</span>

<ng-template #panelTemplate>
  <div
    class="app-select__panel"
    role="listbox"
    tabindex="-1"
    [@transformPanel]="_animationState"
    [attr.id]="id + '-panel'"
    [attr.aria-multiselectable]="multiple"
    [attr.aria-label]="ariaLabel || null"
    [attr.aria-labelledby]="_getAriaLabelledby()"
  >
    <ng-content></ng-content>
  </div>
</ng-template>
